export const handleFontPreview = (value: string, previewAgent: boolean) => {
  const cleanValue = value.replace("px", "");
  const newValue = previewAgent
    ? // ? `${cleanValue}px`
      parseInt(cleanValue) / 17 + "vw"
    : parseInt(cleanValue) / 30 + "vw";

  return newValue;
};

export const handleConvertPxToPt = (value: string, previewAgent: boolean) => {
  const cleanValue = value.replace("px", "");
  const newValue = previewAgent
    ? `${cleanValue}px`
    : parseInt(cleanValue) / 1.2 + "px";

  return newValue;
};
